import React from 'react';
import Select from 'react-select';
import { VOUCHER_STATUSES } from '../../../../../constants/enums';
import { renderVoucherStatusName } from '../../../../../utils/render';
import { getTranslation } from '../../../../../utils/translation';

const VoucherStatus = props => {
    const { selectedStatus, onStatusChange } = props;

    const options = [
        {
            value: VOUCHER_STATUSES.all,
            label: getTranslation('ticketStatusAll'),
        },
        {
            value: VOUCHER_STATUSES.active,
            label: renderVoucherStatusName(VOUCHER_STATUSES.active),
        },
        {
            value: VOUCHER_STATUSES.inactive,
            label: renderVoucherStatusName(VOUCHER_STATUSES.inactive),
        },
        {
            value: VOUCHER_STATUSES.cancelled,
            label: renderVoucherStatusName(VOUCHER_STATUSES.cancelled),
        },
    ];

    const selectedOption = options.find(option => option.value === selectedStatus);

    return (
        <Select
            className='common-select common-select--filters'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedOption}
            onChange={onStatusChange}
            options={options}
        />
    );
};

export default VoucherStatus;
